import { setupHomepageAllAccessExperimentBucketing } from 'client/javascript/pages/home/experiments/allaccess_promo_test';
import { setupHomepageRefreshExperimentBucketing } from './homepage_refresh_phase1_test';

export function setupExperimentsBucketing() {
  setupHomepageRefreshExperimentBucketing();
  setupHomepageAllAccessExperimentBucketing();
}
